import Vue from 'vue'
import VueRouter from 'vue-router'
import acceptLogin from '../common/middleware/acceptLogin'
import auth from '../common/middleware/auth'
import blocked from '../common/middleware/blocked'
import guest from '../common/middleware/guest'
import router from '../common/router/router'
import Blocked from '../views/Blocked.vue'
import Login from '@/views/Login.vue'
import LoginLayout from '@/layouts/LoginLayout'
import Application from '@/views/Application'
import notBlocked from '@/common/middleware/notBlocked'
import redirect from '@/common/middleware/redirect'
import ApplicationList from '@/components/application/ApplicationList.vue'

Vue.use(VueRouter)
export default router([
  {
    path: '/application/vts/create',
    name: 'CreateVTS',
    component: Application,
    children: [
      {
        path: '*'
      }
    ],
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/application/list',
    name: 'application-list',
    component: ApplicationList,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/application/vts/:mode/:id',
    name: 'view-vts',
    component: Application,
    props: route => ({ mode: route.params.mode, appId: route.params.id }),
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/blocked',
    name: 'Blocked',
    component: Blocked,
    meta: {
      middleware: [
        auth,
        blocked
      ]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      middleware: [
        guest
      ],
      layout: LoginLayout
    }
  },
  {
    path: '/login/accept',
    name: 'AcceptLogin',
    meta: {
      middleware: [
        guest,
        acceptLogin
      ]
    }
  },
  {
    path: '/',
    name: 'root',
    meta: {
      middleware: [
        auth,
        notBlocked,
        redirect
      ]
    }
  },
  {
    path: '*',
    meta: {
      middleware: [
        auth,
        guest
      ]
    }
  }
])
